module.exports = __webpack_public_path__ + "static/Tracer Perpetual Pools-efc7c29f638cb788832aafe0f41c07bd.pdf";